var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0H56V32C56 45.2548 45.2548 56 32 56H0V24Z",
    fill: "#0068FF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5601 40.5498V37.2698C44.5601 36.8721 44.8824 36.5498 45.28 36.5498C45.6777 36.5498 46 36.8721 46 37.2698L46.0001 40.5498H49.275C49.6754 40.5498 50 40.8744 50 41.2748C50 41.6752 49.6754 41.9998 49.275 41.9998H46.0001V45.2798C46.0001 45.6774 45.6777 45.9998 45.2801 45.9998C44.8824 45.9998 44.5601 45.6774 44.5601 45.2798V41.9998H41.2851C40.8847 41.9998 40.5601 41.6752 40.5601 41.2748C40.5601 40.8744 40.8847 40.5498 41.2851 40.5498H44.5601Z",
    fill: "#0068FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7623 18.8H42.4C44.385 18.8 46 20.4262 46 22.425V33.83C46 34.2277 45.6776 34.55 45.28 34.55C44.8824 34.55 44.56 34.2277 44.56 33.83V22.425C44.56 21.2258 43.5909 20.25 42.4 20.25H35.2C34.8695 20.25 34.5822 20.0238 34.5016 19.7012L33.3345 14.9995C33.2538 14.6762 32.9666 14.45 32.6361 14.45H23.3646C23.0334 14.45 22.7462 14.6762 22.6655 14.9995L21.4984 19.7012C21.4178 20.0238 21.1305 20.25 20.8 20.25H13.6C12.4091 20.25 11.44 21.2258 11.44 22.425V38.375C11.44 39.5741 12.4091 40.55 13.6 40.55H37.8351C38.2355 40.55 38.5601 40.8746 38.5601 41.275C38.5601 41.6754 38.2355 42 37.8351 42H13.6C11.615 42 10 40.3738 10 38.375V22.425C10 20.4262 11.615 18.8 13.6 18.8H20.2377L21.2687 14.6472C21.5092 13.6779 22.3718 13 23.3646 13H32.6354C33.6282 13 34.4908 13.6779 34.7306 14.6472L35.7623 18.8Z",
    fill: "#0068FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0332 24.621C24.8515 24.621 22.2627 27.2278 22.2627 30.4316C22.2627 33.6354 24.8515 36.2421 28.0332 36.2421C31.2149 36.2421 33.8037 33.6354 33.8037 30.4316C33.8037 27.2278 31.2149 24.621 28.0332 24.621ZM28.0332 34.7895C25.6464 34.7895 23.7054 32.835 23.7054 30.4316C23.7054 28.0282 25.6464 26.0736 28.0332 26.0736C30.42 26.0736 32.3611 28.0282 32.3611 30.4316C32.3611 32.835 30.42 34.7895 28.0332 34.7895Z",
    fill: "#0068FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3775 30.432C19.3775 25.626 23.2603 21.7162 28.0332 21.7162C32.8061 21.7162 36.689 25.626 36.689 30.432C36.689 35.2381 32.8061 39.1479 28.0332 39.1479C23.2603 39.1479 19.3775 35.2381 19.3775 30.432ZM20.8201 30.432C20.8201 34.437 24.0559 37.6953 28.0332 37.6953C32.0105 37.6953 35.2463 34.437 35.2463 30.432C35.2463 26.4271 32.0105 23.1688 28.0332 23.1688C24.0559 23.1688 20.8201 26.4271 20.8201 30.432Z",
    fill: "#0068FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6069 21.7165H17.2135C17.6124 21.7165 17.9348 22.0419 17.9348 22.4428V26.0744C17.9348 26.4754 17.6124 26.8008 17.2135 26.8008H13.6069C13.208 26.8008 12.8856 26.4754 12.8856 26.0744V22.4428C12.8856 22.0419 13.208 21.7165 13.6069 21.7165ZM14.3282 25.3481H16.4922V23.1692H14.3282V25.3481Z",
    fill: "#0068FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b",
    x: -17,
    y: -17,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 8.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileButton);
export default __webpack_public_path__ + "static/media/file_button.0e50aefa32244a276152f75b14a1b5bb.svg";
export { ForwardRef as ReactComponent };